export function matchesConversationSearch({
  query,
  title,
  subtitle,
  description,
}: {
  query: string;
  title: string;
  subtitle?: string;
  description?: string | null;
}): boolean {
  const normalized = query.toLowerCase();
  return [title, subtitle, description]
    .filter((value): value is string => Boolean(value))
    .some((value) => value.toLowerCase().includes(normalized));
}
